<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-card class="mx-auto" max-width="450" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-alert border="top" colored-border type="info" elevation="2">
                Please select a device to view the report.
              </v-alert>
              <v-list-item-title class="text-h5 mb-3"> </v-list-item-title>
              <v-list-item-subtitle
                ><v-autocomplete
                  color="primaryDark"
                  v-model="device_id"
                  :items="assets"
                  :item-text="(item) => `${item.AssetID} - ${item.SiteName}`"
                  label="Select Device"
                  item-value="DeviceID"
                  @change="update_device_id"
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="device_id" class="common-card-row" no-gutters>
      <v-col class="common-card-col" align="center">
        <div class="schedule">
          <v-btn v-if="!under_develop" color="vtblue" @click="openSchedulingPopup" small fixed right dark>
            {{ $t("common.words.schedule") }}
            <v-icon small>mdi-account-clock-outline</v-icon>
          </v-btn>
        </div>
        <div>
          <v-fab-transition
            ><v-btn
              :class="`export-btn ${alerts_tab_status}`"
              color="vtred"
              @click="exportToPDF"
              large
              dark
              fixed
              bottom
              right
              fab
            >
              <v-icon>mdi-export</v-icon>
            </v-btn>
          </v-fab-transition>
        </div>
        <div class="container-width">
          <div ref="header">
            <img height="175" width="600px" id="header" src="/assets/images/h2scan/h2scan_logo.png" />
          </div>
          <div id="document" ref="document" align="start">
            <ScavengerH2DeviceReport :key="device_id" :deviceId="device_id" />
          </div>
          <div ref="footer" v-if="footer_available">
            <img height="50" width="794px" id="footer" src="/assets/images/footer.png" />
          </div>
        </div>
      </v-col>
    </v-row>

    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundWhite"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%">
          <ReportManagement :isPowerData="isPowerData" :deviceId="device_id" />
        </div>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import ScavengerH2DeviceReport from "../components/ScavengerH2DeviceReport.vue";
import ReportManagement from "../components/ReportManagement";
import { axios_get } from "../services/vt_service";
import { h2 } from "../services/powerdata";
import html2pdf from "html2pdf.js";

export default {
  name: "Scavenger_H2_Report",
  components: {
    ScavengerH2DeviceReport,
    ReportManagement,
  },
  data() {
    return {
      assets: [],
      device_id: null,
      dialog: false,
      isPowerData: true,
      under_develop: true,
      footer_available: false,
    };
  },
  mounted() {
    this.device_id = this.$route.params.deviceId;
    this.get_assets();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    async get_assets() {
      let assets = await axios_get(h2.get_scv_h2_assets);
      this.assets = assets.filter((asset) => {
        return asset.DeviceStatus && asset.DeviceStatus.toLowerCase().includes("installed");
      });
    },
    update_device_id() {
      this.$router.push(`/scavenger_h2_report/${this.device_id}`);
    },
    openSchedulingPopup() {
      this.dialog = true;
    },
    exportToPDF() {
      //this.$store.commit("show_loader");
      var opt = {
        margin: [1.8, 0, 1, 0],
        filename: "report_" + new Date().toString() + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.document)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            if (i == 1) {
              pdf.addImage(document.getElementById("header"), "png", 0, 0, 8.27, 2);
            }
            pdf.addImage(
              document.getElementById("footer"),
              "png",
              0,
              pdf.internal.pageSize.getHeight() - 0.4,
              8.27,
              0.4
            );
          }
        })
        .save();
      this.$store.commit("hide_loader");
    },
  },
  computed: {
    show_export_btn: function () {
      return this.$route.name == "Report_Snapshot" ? false : true;
    },
    is_scavenger: function () {
      return this.$store.state.tenant_config
        ? this.$store.state.tenant_config.powerdata_type == "scavenger" ||
            this.$store.state.tenant_config.powerdata_type == "h2scan"
        : false;
    },
    show_alerts: function () {
      return (
        this.$store.state.tenant_config.show_alerts_section &&
        ("alerts_enabled" in this.$store.state.user_config ? this.$store.state.user_config.alerts_enabled : true)
      );
    },
    alerts_tab_status: function () {
      return this.is_scavenger && this.show_alerts
        ? this.$store.state.show_right_nav_bar
          ? "alerts-open"
          : "alerts-close"
        : "no-alerts";
    },
  },
};
</script>

<style lang="scss" scoped>
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.schedule {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.schedule-btn {
  z-index: 9;
}

.report-border {
  border: 1px solid var(--v-borderDark-base) !important;
  border-radius: 0.5%;
}
.export-btn {
  z-index: 9;
  &.alerts-open {
    right: 410px;
  }
  &.alerts-close {
    right: 60px;
  }
}
</style>
